module.exports = __webpack_public_path__ + "img/15-1.b7be517b.png";